import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC0xWTiom6D5JlziMX4VlQgEcSPISF5uOY",
  authDomain: "symuliga.firebaseapp.com",
  projectId: "symuliga",
  storageBucket: "symuliga.firebasestorage.app",
  messagingSenderId: "195368944811",
  appId: "1:195368944811:web:3e355b29e09c213257e3ee",
  measurementId: "G-HVTPR97991"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Poprawna funkcja getIdToken
export const getIdToken = async (forceRefresh = false) => {
  const user = auth.currentUser;
  if (user) {
    try {
      const token = await user.getIdToken(forceRefresh); // Poprawna metoda Firebase
      return token;
    } catch (error) {
      console.error('Błąd podczas pobierania tokena:', error);
      return null;
    }
  }
  return null; // Zwraca null, jeśli użytkownik nie jest zalogowany
};